import { PieChart, User, Coins } from 'lucide-react';

export default function DistributionChart({ initialPoolPercentage, finalPoolPercentage }) {
  const finalPool = Number(finalPoolPercentage) || 0;
  const dev = Math.max(0, 100 - finalPool);

  return (
    <div className="rounded-xl border border-border bg-card p-4 sm:p-6 shadow-sm">
      <h3 className="text-sm sm:text-base font-semibold mb-4 flex items-center" data-testid="bundle-distribution-title">
        <PieChart className="mr-2 w-4 h-4 text-purple-500" />
        Token Distribution
      </h3>

      <div className="mb-5">
        <h4 className="text-xs font-medium text-muted-foreground mb-2">Initial Distribution</h4>
        <div className="relative h-6 bg-muted rounded-full overflow-hidden">
          <div className="absolute inset-0 bg-blue-500/80 flex items-center justify-center">
            <span className="text-xs text-white font-medium">100% Liquidity Pool</span>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h4 className="text-xs font-medium text-muted-foreground mb-2">Final Distribution (After Bundle)</h4>
        <div className="relative h-6 bg-muted rounded-full overflow-hidden">
          <div
            className="absolute top-0 left-0 h-full bg-blue-500/80 flex items-center justify-end px-2"
            style={{ width: `${finalPool}%` }}
          >
            {finalPool >= 15 && <span className="text-xs text-white font-medium">{finalPool.toFixed(1)}%</span>}
          </div>
          <div
            className="absolute top-0 h-full bg-purple-500/80 flex items-center justify-start px-2"
            style={{ width: `${dev}%`, left: `${finalPool}%` }}
          >
            {dev >= 15 && <span className="text-xs text-white font-medium">{dev.toFixed(1)}%</span>}
          </div>
        </div>
        <div className="flex justify-between mt-2 text-[11px] text-muted-foreground">
          <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 bg-blue-500 rounded-full" /> Liquidity Pool</span>
          <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 bg-purple-500 rounded-full" /> Developer (Bundled)</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-5">
        <div className="p-3 rounded-lg bg-muted/40 border border-border flex items-center gap-3">
          <div className="p-2 rounded-full bg-blue-500/15">
            <Coins className="w-4 h-4 text-blue-500" />
          </div>
          <div>
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider">In Pool</div>
            <div className="text-base font-bold font-mono">{finalPool.toFixed(1)}%</div>
          </div>
        </div>
        <div className="p-3 rounded-lg bg-muted/40 border border-border flex items-center gap-3">
          <div className="p-2 rounded-full bg-purple-500/15">
            <User className="w-4 h-4 text-purple-500" />
          </div>
          <div>
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider">Developer</div>
            <div className="text-base font-bold font-mono">{dev.toFixed(1)}%</div>
          </div>
        </div>
      </div>
    </div>
  );
}
